export const BASE_URL = process.env.REACT_APP_AUTH_URL;
export const PDF_URL = process.env.REACT_APP_PDF_API_URL;
